import { type SvgProps, SvgWrapper } from '../utils';

export function MenuIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M20.75 5.25H3.25C2.83579 5.25 2.5 4.91421 2.5 4.5C2.5 4.08579 2.83579 3.75 3.25 3.75H20.75C21.1642 3.75 21.5 4.08579 21.5 4.5C21.5 4.91421 21.1642 5.25 20.75 5.25Z" />
      <path d="M20.75 12.75H3.25C2.83579 12.75 2.5 12.4142 2.5 12C2.5 11.5858 2.83579 11.25 3.25 11.25H20.75C21.1642 11.25 21.5 11.5858 21.5 12C21.5 12.4142 21.1642 12.75 20.75 12.75Z" />
      <path d="M20.75 20.25H3.25C2.83579 20.25 2.5 19.9142 2.5 19.5C2.5 19.0858 2.83579 18.75 3.25 18.75H20.75C21.1642 18.75 21.5 19.0858 21.5 19.5C21.5 19.9142 21.1642 20.25 20.75 20.25Z" />
    </SvgWrapper>
  );
}
